module.exports = __webpack_public_path__ + "assets/img/fix_openEn.5b85f521.png";